import gql from 'graphql-tag';

export class EidEasyMutations {
  static prepareEidEasyDoc = gql`
    mutation prepareEidEasyDoc {
      prepareEidEasyDoc
    }
  `;
}
